const PDF_ROUTE_PATTERN = /\/pdf\/?$/;

export const isOnlineOfferPdfRoute = (pathname: string) => PDF_ROUTE_PATTERN.test(pathname);
